import FacetsFilters from './FacetsFilters.vue'

export default FacetsFilters
